export interface ValidatePartnerCommand {
  partnerId: number;
}

export class PartnerCommands {
  static getValidatePartnerCommand(partnerId: number): ValidatePartnerCommand {
    return {
      partnerId,
    };
  }
}
